<template>
  <v-dialog :value="value" width="600px" persistent @input="updateDialog">
    <v-card>
      <v-card-title class="subtitle-1">Breakfast Technical</v-card-title>

      <v-card-text>
        <f-textarea :value="draftNotes" rows="6" @input="(v) => (draftNotes = v)" />
      </v-card-text>

      <v-card-actions>
        <div class="flex-grow-1"></div>
        <g-button label="Cancel" icon="clear" @onclick="closeDialog" />
        <g-button type="primary" label="Save" icon="save" @onclick="saveNotes" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "BreakfastTechnicalDialog",
  props: {
    value: Boolean,
    notes: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      draftNotes: this.notes || "",
    };
  },
  watch: {
    value(open) {
      if (open) this.draftNotes = this.notes || "";
    },
  },
  methods: {
    updateDialog(value) {
      this.$emit("input", value);
    },
    closeDialog() {
      this.updateDialog(false);
    },
    saveNotes() {
      this.$emit("save", this.draftNotes);
      this.closeDialog();
    },
  },
};
</script>
